import React from "react";
import {
  Header,
  Container,
  Grid,
  Button,
  Message,
  Icon,
  List
} from "semantic-ui-react";
import HotelStructure from "../rooms/HotelStructure";
const HomeComponent = props => {
  return (
    <Container fluid>
      {props.legendMessageVisible && (
        <Message
          info
          onDismiss={() => {
            props.toggleMessage("legendMessage");
            if (props.isSynchronizing) {
              props.toggleMessage("infoDashboardMessage");
            }
          }}>
          <Message.Content>
            <Message.Header>{props.t("hotelStructure:legend")}</Message.Header>
            <List>
              <List.Item>
                <Icon name="stop" color="blue" /> {props.t("occupancy:clean")}
              </List.Item>
              <List.Item>
                <Icon name="stop" color="yellow" />{" "}
                {props.t("occupancy:cleaning")}
              </List.Item>
              <List.Item>
                <Icon name="stop" color="green" />{" "}
                {props.t("occupancy:cleaned")}
              </List.Item>
              <List.Item>
                <Icon name="stop" color="red" /> {props.t("occupancy:dirty")}
              </List.Item>
            </List>
          </Message.Content>
        </Message>
      )}
      {props.infoMessageVisible &&
        !props.isSynchronizing && (
          <Message
            info
            icon
            onDismiss={() => props.toggleMessage("infoDashboardMessage")}>
            <Icon name="help" />
            <Message.Content>
              <Message.Header>Info</Message.Header>
              {props.t("message:dashboard:info")}
            </Message.Content>
          </Message>
        )}

      <Grid columns="equal">
        <Grid.Column>
          <Header as="h1" content={props.hotel.hotelName} />
        </Grid.Column>
        <Grid.Column textAlign="right">
          {!props.infoMessageVisible &&
            !props.legendMessageVisible && (
              <Button
                icon
                onClick={() => {
                  props.toggleMessage("legendMessage");
                  props.toggleMessage("infoDashboardMessage");
                }}
                style={{ backgroundColor: "#5a697b" }}>
                <Icon name="help" style={{ color: "white" }} />
              </Button>
            )}
        </Grid.Column>
      </Grid>
      <Grid stackable columns="equal">
        <Grid.Column textAlign="right">
          <Button.Group>
            <Button
              color="orange"
              icon="arrow left"
              onClick={props.decrementDate}
            />
            <Button color="orange">{props.date.format("DD-MM-YYYY")}</Button>
            <Button
              color="orange"
              icon="arrow right"
              onClick={props.incrementDate}
            />
          </Button.Group>
        </Grid.Column>
      </Grid>
      <HotelStructure />
    </Container>
  );
};

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/components/HomeComponent.js